<template>
  <div>
    <h3 class="py-0 my-0 mb-6 text-xl text-gray-800">
      Zugeordnete Fahrzeuge
    </h3>

    <mia-wait for="loading cars">
      <template #waiting>
        <div class="flex items-center justify-center py-8">
          <mia-wave-loader />
        </div>
      </template>

      <template #default>
        <datatable
          class="w-full table-auto datatable"
          :data="cars"
          :columns="columns"
        >
          <template #default="{ row }">
            <tr
              :key="row.id"
              class="cursor-pointer"
              @click="showDetails(row)"
            >
              <td>{{ row.item_numberplate }}</td>
              <td>{{ row.item_fin }}</td>
              <td>{{ row.item_lastname }}{{ row.item_firstname ? `, ${row.item_firstname}` : '' }}</td>
              <mia-has-feature feature="advanced_order_confirmation">
                <td>
                  <div
                    v-if="row.item_order_confirmation_confirmed_at"
                    class="flex items-center"
                  >
                    <mia-streamline-icon
                      class="w-5 h-5 text-green-500 fill-current"
                      src="check-circle-1"
                    />
                    <span class="ml-2">Bestätigt am {{ row.item_order_confirmation_confirmed_at | datetime }} Uhr</span>
                  </div>
                  <div v-else-if="row.item_order_confirmation_sent_at">
                    <div class="flex items-center">
                      <mia-streamline-icon
                        class="w-5 h-5 text-orange-500 fill-current"
                        src="time-clock-circle-1"
                      />
                      <span class="ml-2">Bestätigung ausstehend</span>
                    </div>
                    <div class="italic mt-1 text-sm">
                      Benachrichtigung verschickt am {{ row.item_order_confirmation_sent_at | datetime }} Uhr
                    </div>
                  </div>
                  <div
                    v-else
                    class="italic"
                  >
                    Auftragsbestätigung noch nicht versandt
                  </div>
                </td>
              </mia-has-feature>
            </tr>
          </template>
          <template #no-results>
            <div class="text-center">
              Keine zugeordneten Fahrzeuge gefunden
            </div>
          </template>
        </datatable>
      </template>
    </mia-wait>
  </div>
</template>

<script>
import { getCars } from '@/api/customer'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    cars: []
  }),

  computed: {
    ...mapGetters('customers', ['customer']),

    columns() {
      const columns = [
        {
          field: 'item_numberplate',
          label: 'Kennzeichen',
          headerAlign: 'left'
        },
        {
          field: 'item_fin',
          label: 'Fahrzeug',
          headerAlign: 'left'
        },
        {
          field: 'item_assignee',
          label: 'Zuständiger',
          headerAlign: 'left'
        }
      ]

      if (this.authDealer.item_is_allowed_advanced_order_confirmation) {
        columns.push({
          field: 'item_fin',
          label: 'Status Auftragsbestätigung',
          headerAlign: 'left'
        })
      }

      return columns
    }
  },

  created() {
    this.loadCars()
  },

  methods: {
    async loadCars() {
      this.$wait.start('loading cars')
      const [errors, cars] = await getCars(this.customer.id)
      this.$wait.end('loading cars')

      if (errors) {
        window.eventBus.$emit('mia-error', {
          errors: ['Fahrzeuge konnten nicht geladen werden']
        })
        return
      }

      this.cars = cars
    },

    showDetails(car) {
      this.$router.push(`/cars/${car.id}`)
    }
  }
}
</script>
